<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import type { VariantProps } from 'tailwind-variants';
	import { focusSibling } from '$lib/utils/focus';
	import { tv } from '../tv';
	import { CONTAINER_COLOR_VARIANTS } from '../variants';

	export const menuVariants = tv({
		base: 'overflow-hidden rounded-r400 border-b300 border-solid border-(--v-container-line) bg-(--v-container) text-(--v-on-container) shadow-e200',
		variants: { variant: CONTAINER_COLOR_VARIANTS },
		defaultVariants: { variant: 'Surface' }
	});

	export interface MenuProps
		extends Omit<HTMLAttributes<HTMLElement>, 'class'>, VariantProps<typeof menuVariants> {
		arrowNavigation?: boolean;
		as?: string;
		children?: Snippet;
		class?: ClassValue;
		ref?: HTMLElement | null;
	}
</script>

<script lang="ts">
	let {
		arrowNavigation = true,
		as = 'div',
		children,
		class: className,
		onkeydown,
		ref = $bindable(null),
		variant,
		...rest
	}: MenuProps = $props();

	const handleKeydown = (event: KeyboardEvent & { currentTarget: EventTarget & HTMLElement }) => {
		onkeydown?.(event);
		if (!arrowNavigation || event.defaultPrevented) return;
		if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
		event.preventDefault();
		focusSibling(event.currentTarget, event.key === 'ArrowDown' ? 'next' : 'prev');
	};
</script>

<svelte:element
	this={as}
	bind:this={ref}
	class={[menuVariants({ variant }), className]}
	onkeydown={handleKeydown}
	{...rest}
>
	{@render children?.()}
</svelte:element>
